module.exports = __webpack_public_path__ + "static/media/85x11no1.f5529a94.jpg";